import { useCallback } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DateTimePicker, DateView, LocalizationProvider } from '@mui/x-date-pickers';
import { FormControl, FormHelperText, Grid2 as Grid } from "@mui/material";
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from "dayjs";

type DatePickerProps = {
    label: string,
    value: dayjs.Dayjs | null,
    setValue: (v: dayjs.Dayjs | null) => void,
    required?: boolean,
    error?: string,
    disabled?: boolean,
    views?: DateView[],
    format?: string,
    includeTime?: boolean,
    disablePast?: boolean,
    excludeToday?: boolean,
    size?: number
}

const FormDatePicker = ({
    label,
    value,
    setValue,
    required = false,
    error = "",
    disabled = false,
    views,
    format,
    includeTime = false,
    disablePast = false,
    excludeToday = false,
    size = 6
}: DatePickerProps) => {
    const getTomorrow = useCallback(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0,0,0,0);
        return tomorrow;
    }, []);

    return (
        <Grid size={size}>
            <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {includeTime ? (
                        <DateTimePicker
                            label={label}
                            value={value}
                            views={views}
                            format={format}
                            onChange={(newValue) => setValue(newValue)}
                            disabled={disabled}
                            disablePast={disablePast}
                            minDateTime={excludeToday ? dayjs(getTomorrow()) : undefined}
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: null,
                                seconds: null,
                            }}
                            skipDisabled={true}
                        />
                    ) : (
                        <DatePicker
                            label={label}
                            value={value}
                            views={views}
                            format={format}
                            onChange={(newValue) => setValue(newValue)}
                            disabled={disabled}
                            disablePast={disablePast}
                            minDate={excludeToday ? dayjs(getTomorrow()) : undefined}
                        />
                    )}
                </LocalizationProvider>
                <FormHelperText sx={{ color: error !== "" ? '#f44336' : '' }}>
                    {error !== "" ? error : required ? "Required" : ""}
                </FormHelperText>
            </FormControl>
        </Grid>
    )
}

export default FormDatePicker;
